import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

let _ = t => t,
    _t;

import { Fragment, useEffect, useMemo } from 'react';
import Immutable from 'immutable';
import { createGlobalStyle } from 'styled-components';
import { GRID_BREAKPOINT_MEDIUM } from 'HubStyleTokens/sizes';
import getLang from 'I18n/utils/getLang'; // @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'mark... Remove this comment to see the full error message

import { Header, Footer } from 'marketing-dot-com-nav';
import { useWindowDimensionsContext } from '../hooks/useWindowDimensionsContext';
import { MAIN_SECTION_MAX_WIDTH, MAIN_SECTION_PADDING_X } from '../layout/constants';
import { getFullPublicUrl } from '../utils/urls';
const GRID_BREAKPOINT_MEDIUM_INT = parseInt(GRID_BREAKPOINT_MEDIUM, 10);
const MarketingNavGlobalStyle = createGlobalStyle(_t || (_t = _`
  .hsg-page-width-normal,
  .hs-page-width-normal {
    max-width: ${0}px !important;
    padding: 0 !important;

    @media (min-width: 768px) {
      padding: 0 ${0}px !important;
    }
  }

  .hsg-nav__group-item.hsg-nav__group-item--cta {
    @media (min-width: 768px) {
      padding-right: 0;
    }
  }

  .hsg-nav__group-item.hsg-nav__group-item--search {
    display: none;
  }

  .hsg-nav__group-item > #hsg-nav__logo > #hsg-nav__logo-mobile {
    display: none;
  }

  .hsg-footer__layout {
    max-width: ${0}px !important;
    padding: 0 !important;

    @media (min-width: 768px) {
      padding: 0 ${0}px !important;
    }
  }
`), MAIN_SECTION_MAX_WIDTH, MAIN_SECTION_PADDING_X, MAIN_SECTION_MAX_WIDTH, MAIN_SECTION_PADDING_X);
export default function MarketingNav({
  children,
  enableConvertFlag = true,
  footerContentBlob: __footerContentBlob = {},
  headerContentBlob = {}
}) {
  const lang = getLang();
  const MarketingNavHeader = useMemo(() => {
    if (lang === 'ja') {
      return Header.jp;
    } else if (lang in Header) {
      return Header[lang];
    }

    return Header.en;
  }, [lang]);
  const computedHeaderContentBlob = useMemo(() => {
    const {
      contentBlob: defaultHeaderContentBlob
    } = MarketingNavHeader;
    const defaultHomeUrl = getFullPublicUrl(lang);
    return Immutable.fromJS(defaultHeaderContentBlob || {}).mergeDeep(headerContentBlob).mergeDeep({
      upperNavContent: {
        homeUrl: defaultHomeUrl
      },
      mobileNavContent: {
        homeUrl: defaultHomeUrl
      }
    }).toJS();
  }, [MarketingNavHeader, headerContentBlob, lang]);
  const {
    width: windowWidth
  } = useWindowDimensionsContext();
  const computedHeaderVariation = windowWidth < GRID_BREAKPOINT_MEDIUM_INT ? 'default' : 'marketplace';
  const MarketingNavFooter = useMemo(() => {
    if (lang === 'ja') {
      return Footer.jp;
    } else if (lang in Footer) {
      return Footer[lang];
    }

    return Footer.en;
  }, [lang]);
  useEffect(() => {
    if (headerContentBlob.upperNavContent && headerContentBlob.upperNavContent.homeUrl || headerContentBlob.mobileNavContent && headerContentBlob.mobileNavContent.homeUrl) {
      console.warn('[MarketingNav] Custom homeUrl passed, using default instead.');
    }
  }, [headerContentBlob]);
  return /*#__PURE__*/_jsxs(Fragment, {
    children: [/*#__PURE__*/_jsx(MarketingNavGlobalStyle, {}), /*#__PURE__*/_jsx(MarketingNavHeader, {
      contentBlob: computedHeaderContentBlob,
      enableConvertFlag: enableConvertFlag,
      isLoggedIn: false,
      variation: computedHeaderVariation
    }), children, /*#__PURE__*/_jsx(MarketingNavFooter, {})]
  });
}